var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"transactions"},_vm._l((_vm.transactions),function(transaction,index){return _c('transaction',{key:index,attrs:{"transaction":transaction,"extend-line":index < (_vm.transactions.length - 1)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }